import { List, ListItem, Typography, Divider, ListItemText } from "@mui/material";
// @ts-ignore
import { getPrecipUnit } from '../../lib/Formatters';
import type { TooltipProps } from 'recharts';
import {
    ValueType,
    NameType
} from 'recharts/types/component/DefaultTooltipContent';
// @ts-ignore
import { DateTime } from 'luxon';

interface HistoricalComparisonCustomTooltipProps extends TooltipProps<ValueType, NameType> {
    uom: string,
    orgTempUnit: string;
    chartType: string;
}

export const HistoricalComparisonCustomTooltip = (props: HistoricalComparisonCustomTooltipProps) => {
    const { active, payload, uom, orgTempUnit, chartType } = props;

    if (active && payload?.length) {
        if (chartType === "day") {
            // Need to adjust the tooltip in case the date range spans to the following year
            const yearOneDate = DateTime.fromISO(payload[0]?.payload.yearOneDate);
            payload[0].name = yearOneDate.year.toString();
            const yearTwoDate = DateTime.fromISO(payload[1]?.payload.yearTwoDate);
            payload[1].name = yearTwoDate.year.toString();
        }

        return (
            <div className="custom-tooltip">
                <List className='historicalComparisonYearTooltip'
                    sx={{
                        width: '100%',
                        minWidth: '250px',
                        bgcolor: 'background.paper',
                        border: '1px solid #cccccc',
                        borderRadius: '5px',
                        padding: '5px'
                    }}
                    component="nav"
                    dense
                >
                    <ListItem>
                        <Typography gutterBottom variant="h6">
                            {payload[0].payload.tooltipText}
                        </Typography>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText
                            sx={{ color: payload[0]?.color }}
                            primaryTypographyProps={{ fontSize: '15px', fontWeight: 'bold' }}
                            primary={payload[0].name}
                            secondaryTypographyProps={{ fontSize: '13px' }}
                            secondary={"Total: " + payload[0].payload.totalUsageYearOne.toFixed(2) + " " + uom}
                        />
                    </ListItem>
                    {payload[0].payload.weatherDataYearOne && (
                        <ListItem>
                            <ListItemText
                                sx={{ color: payload[0]?.color }}
                                secondaryTypographyProps={{ fontSize: '13px' }}
                                secondary={"Avg. Temp. " + payload[0].payload.weatherDataYearOne + String.fromCharCode(176) + orgTempUnit}
                            />
                        </ListItem>
                    )}
                    {payload[0].payload.precipDataYearOne >= 0 && (
                        <ListItem>
                            <ListItemText
                                sx={{ color: payload[0]?.color }}
                                secondaryTypographyProps={{ fontSize: '13px' }}
                                secondary={"Precip. " + payload[0].payload.precipDataYearOne + getPrecipUnit(orgTempUnit)}
                            />
                        </ListItem>
                    )}
                    <Divider />
                    <ListItem>
                        <ListItemText
                            sx={{ color: payload[1]?.color }}
                            primaryTypographyProps={{ fontSize: '15px', fontWeight: 'bold' }}
                            primary={payload[1].name}
                            secondaryTypographyProps={{ fontSize: '13px' }}
                            secondary={"Total: " + payload[0].payload.totalUsageYearTwo.toFixed(2) + " " + uom}
                        />
                    </ListItem>
                    {payload[0].payload.weatherDataYearTwo && (
                        <ListItem>
                            <ListItemText
                                sx={{ color: payload[0]?.color }}
                                secondaryTypographyProps={{ fontSize: '13px' }}
                                secondary={"Avg. Temp. " + payload[0].payload.weatherDataYearTwo + String.fromCharCode(176) + orgTempUnit}
                            />
                        </ListItem>
                    )}               
                    {payload[0].payload.precipDataYearTwo >= 0 && (
                        <ListItem>
                            <ListItemText
                                sx={{ color: payload[0]?.color }}
                                secondaryTypographyProps={{ fontSize: '13px' }}
                                secondary={"Precip. " + payload[0].payload.precipDataYearTwo + getPrecipUnit(orgTempUnit)}
                            />
                        </ListItem>
                    )}              
                </List>
            </div>
        );
    }
    return null;
};